import React, { ComponentProps, Suspense } from 'react';
import type ImageCropper from './ImageCropper';
import { LoadingSpinnerContainer } from '../../atoms/LoadingSpinner';

const ImageCropperComponent = React.lazy(() => import(/* webpackChunkName: "imagecropper" */ './ImageCropper'));

export function LazyImageCropper(props: ComponentProps<typeof ImageCropper>) {
  return (
    <Suspense fallback={<LoadingSpinnerContainer />}>
      <ImageCropperComponent {...props} />
    </Suspense>
  );
}
